import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Newsletter from "@/pages/Newsletter";

export const Route = createFileRoute("/en/newsletter")({
  head: () => buildRouteHead("/en/newsletter"),
  component: Newsletter,
});

